import * as ko from 'knockout';
import i18n from '../../i18n';
import { app } from '../../app';
import { Deferred } from '../../utils/deferred';
import * as weatherApi from '../../api/weather';

const template =
  require('raw-loader!../../../templates/components/trial_wizard/trial_weather_import.html').default;

class TrialWeatherImport {
  loading = ko.observable(false);

  title = ko.observable(i18n.t('Import weather data')());
  description = i18n.t('Upload an Excel file with weather data to import it into this trial.')();
  backTitle = '';
  templateBaseName = 'weather_import_template';
  downloadTemplate = async () => {
    return await weatherApi.getWeatherTemplate();
  };
  importUrl = () =>
    `/api/weather/import/?duplicate_action=${this.duplicateAction()}&trial_id=${this.trialId}`;

  duplicateActionOptions: {
    id: string;
    name: string;
  }[] = [
    { id: 'insert', name: i18n.t('Add all records')() },
    {
      id: 'update_duplicates',
      name: i18n.t('Update records with the same site and day (overwrites existing data)')(),
    },
    {
      id: 'ignore_duplicates',
      name: i18n.t('Ignore records with the same site and day')(),
    },
  ];

  duplicateAction = ko.observable('insert');

  private result: Deferred<any[]>;
  private trialId: string;

  constructor(params: { result: Deferred<any[]>; trialId: string }) {
    this.result = params.result;
    this.trialId = params.trialId;
  }

  onCancel = () => {
    this.result.resolve([]);
  };
}

const name = 'trial-weather-import';

ko.components.register(name, {
  viewModel: TrialWeatherImport,
  template,
});

export function openImportWeather(trialId: string): Promise<any[]> {
  return app.formsStackController.push({
    title: i18n.t('Import weather')(),
    name,
    showNav: true,
    className: name,
    params: {
      result: new Deferred<any[]>(),
      trialId: trialId,
    },
  });
}
